import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { environment } from 'src/environments/environment';

import { FireModule } from '@fo-angular/fire';
import { FormsModule } from '@angular/forms';
import { StripeModule } from './modules/stripe/stripe.module';
import { PayPalModule } from './modules/paypal/paypal.module';

import { LoginComponent } from './components/view/login/login.component';
import { DeliveryOrderComponent } from './components/view/delivery-order/delivery-order.component';
import { DeliveryPaymentComponent } from './components/view/delivery-payment/delivery-payment.component';
import { HereModule } from './modules/here/here.module';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  declarations: [
    AppComponent, 
    LoginComponent,
    DeliveryOrderComponent,
    DeliveryPaymentComponent
  ],
  entryComponents: [
    LoginComponent,
    DeliveryOrderComponent,
    DeliveryPaymentComponent
  ],
  imports: [
    BrowserModule, 
    IonicModule.forRoot(), 
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    FireModule.forRoot(environment.firebase),
    StripeModule,
    PayPalModule
  ],
  providers: [
    StatusBar,
    SplashScreen,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
